import {
  Debounce,
  GlobalEvents,
  SnippetElement,
  defineElement,
  liquidValue,
  on,
  queryAll,
  wait
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/pb-common-variant-picker/pb-common-variant-picker.ts
var PbCommonVariantPicker = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.debouncedVariantChange = (elm) => {
    };
  }
  handleClick(elm) {
    wait(50).then(() => {
      this.debouncedVariantChange(elm);
    });
  }
  connectedCallback() {
    return __async(this, null, function* () {
      const fieldsets = this.querySelectorAll("fieldset");
      fieldsets.forEach((fieldset, index) => {
        var _a;
        let sorted = false;
        let i, shouldSwitch;
        let count = 0;
        while (!sorted && count < 200) {
          count++;
          const options = fieldset.querySelectorAll("[data-form-group]");
          for (i = 0; i < options.length - 1; i++) {
            shouldSwitch = false;
            const option = options[i];
            const optionText = option.innerText.toLowerCase().trim();
            const nextOptionText = options[i + 1].innerText.toLowerCase().trim();
            if (!optionText || !nextOptionText || Number.isNaN(parseInt(optionText)) || Number.isNaN(parseInt(nextOptionText))) {
              continue;
            }
            if (parseInt(optionText) > parseInt(nextOptionText)) {
              shouldSwitch = true;
              break;
            }
          }
          if (shouldSwitch) {
            (_a = options[i].parentNode) == null ? void 0 : _a.insertBefore(options[i + 1], options[i]);
          } else {
            sorted = true;
          }
        }
      });
      this.debouncedVariantChange = Debounce.debounce((elm) => {
        this.handleVariantChange(elm);
      }, 50);
      this.debouncedVariantChange();
    });
  }
  isVariantTracked(variant) {
    return variant.inventory_policy == "continue" && variant.inventory_management == "shopify" || variant.inventory_management == null && variant.inventory_quantity > 0 || variant.available;
  }
  //@globalOn('product:variantChanged')
  handleVariantChange(elm) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const inputs = this.querySelectorAll("[data-input]");
      const x = this.closest("util-product-form");
      const option1 = x == null ? void 0 : x.formObj.option1;
      const option2 = x == null ? void 0 : x.formObj.option2;
      const option3 = x == null ? void 0 : x.formObj.option3;
      const variants = (this.showUnavailable ? this.variants : this.variants.filter((v) => v.available)).filter((v) => this.isVariantTracked(v));
      const currentVariant = variants.find((v) => v.option1 == option1 && v.option2 == option2 && v.option3 == option3);
      const relevantOption2s = [...new Set(variants.filter((v) => v.option1 == option1).map((v) => v.option2))];
      const relevantOption3s = [...new Set(variants.filter((v) => v.option1 == option1 && v.option2 == option2 && relevantOption2s.includes(v.option2)).map((v) => v.option3))];
      const relevantVariantOption2s = [...new Set(variants.filter((v) => v.option1 == option1))];
      const relevantVariantOption3s = [...new Set(variants.filter((v) => v.option1 == option1 && v.option2 == option2 && relevantOption2s.includes(v.option2)))];
      let inputValue = null;
      inputs.forEach((input) => {
        var _a2, _b2, _c2;
        const { name, value } = input;
        if (name == "option2" && !relevantOption2s.includes(value)) {
          input.checked = false;
          (_a2 = input.closest("[data-form-group]")) == null ? void 0 : _a2.classList.add("hidden");
        } else if (name == "option3" && !relevantOption3s.includes(value)) {
          input.checked = false;
          (_b2 = input.closest("[data-form-group]")) == null ? void 0 : _b2.classList.add("hidden");
        } else {
          (_c2 = input.closest("[data-form-group]")) == null ? void 0 : _c2.classList.remove("hidden");
        }
        if (elm && elm.value == value) {
          inputValue = elm.value;
        }
      });
      if (elm && inputValue) {
        const avaibleVariants = variants.filter((v) => v.available);
        const avaibleRelevantOption2s = [...new Set(avaibleVariants.filter((variant2) => variant2.option1 == option1))];
        const avaibleRelevantOption3s = [...new Set(avaibleVariants.filter((variant2) => variant2.option1 == option1 && variant2.option2 == option2 && avaibleRelevantOption2s.find((v2) => v2.option2 == variant2.option2)))];
        let variant;
        if (avaibleRelevantOption3s.length == 0) {
          if (avaibleRelevantOption2s.length == 0) {
            variant = (_a = relevantVariantOption2s[0]) != null ? _a : null;
          } else {
            variant = avaibleRelevantOption2s.find((optionVariant2) => relevantVariantOption3s.find((optionVariant3) => {
              var _a2;
              return optionVariant3.option2 == optionVariant2.option2 && optionVariant3.option3 == optionVariant2.option3 && optionVariant2.option2 == ((_a2 = this.previousVariant) == null ? void 0 : _a2.option2);
            }));
            if (!variant) {
              variant = (_c = (_b = avaibleRelevantOption2s[0]) != null ? _b : relevantOption2s[0]) != null ? _c : null;
            } else {
            }
          }
        } else {
          if (avaibleRelevantOption2s.length == 0) {
            variant = (_d = relevantVariantOption2s[0]) != null ? _d : null;
          } else {
            variant = avaibleRelevantOption3s.find((optionVariant3) => avaibleRelevantOption2s.find((optionVariant2) => {
              var _a2;
              return optionVariant2.option2 == optionVariant3.option2 && optionVariant2.option3 == optionVariant3.option3 && optionVariant3.option3 == ((_a2 = this.previousVariant) == null ? void 0 : _a2.option3);
            }));
            if (elm.name === "option3" && (variant == null ? void 0 : variant.option3) != elm.value) {
              variant = avaibleRelevantOption3s.find((optionVariant3) => avaibleRelevantOption2s.find((optionVariant2) => optionVariant2.option2 == optionVariant3.option2 && optionVariant2.option3 == optionVariant3.option3 && optionVariant3.option3 == elm.value));
            }
            if (!variant) {
              variant = (_f = (_e = avaibleRelevantOption3s[0]) != null ? _e : relevantOption3s[0]) != null ? _f : null;
            } else {
            }
          }
        }
        if (elm.name == "option1") {
          const fset1 = this.fieldsets.find((f) => f.getAttribute("index") == "option1");
          const tempInput1 = fset1 == null ? void 0 : fset1.querySelector(`[value="${inputValue}"]`);
          if (tempInput1)
            tempInput1.checked = true;
          const fset2 = this.fieldsets.find((f) => f.getAttribute("index") == "option2");
          fset2 == null ? void 0 : fset2.querySelectorAll(`[data-input]`).forEach((input) => {
            input.removeAttribute("checked");
            input.checked = false;
          });
          const tempInput2 = fset2 == null ? void 0 : fset2.querySelector(`[value="${variant == null ? void 0 : variant.option2}"]`);
          if (tempInput2)
            tempInput2.checked = true;
          const fset3 = this.fieldsets.find((f) => f.getAttribute("index") == "option3");
          fset3 == null ? void 0 : fset3.querySelectorAll(`[data-input]`).forEach((input) => {
            input.removeAttribute("checked");
            input.checked = false;
          });
          const tempInput3 = fset3 == null ? void 0 : fset3.querySelector(`[value="${variant == null ? void 0 : variant.option3}"]`);
          if (tempInput3)
            tempInput3.checked = true;
          let toShowOptions = [];
          if (((_g = this.previousVariant) == null ? void 0 : _g.option2) != (variant == null ? void 0 : variant.option2)) {
            toShowOptions = [...new Set(variants.filter((v) => v.option1 == (variant == null ? void 0 : variant.option1) && v.option2 == (variant == null ? void 0 : variant.option2) && relevantOption2s.includes(v.option2)).map((v) => v.option3))];
          }
          (_h = fset3 == null ? void 0 : fset3.querySelectorAll(`[data-form-group]`)) == null ? void 0 : _h.forEach((group) => {
            var _a2;
            const value = (_a2 = group.querySelector(`[data-input]`)) == null ? void 0 : _a2.value;
            if (value && relevantOption3s.includes(value) || toShowOptions.includes(value)) {
              group.classList.remove("hidden");
            }
          });
        } else if (elm && elm.name == "option2") {
          const fset2 = this.fieldsets.find((f) => f.getAttribute("index") == "option2");
          const tempInput2 = fset2 == null ? void 0 : fset2.querySelector(`[value="${inputValue}"]`);
          if (tempInput2)
            tempInput2.checked = true;
          const fset3 = this.fieldsets.find((f) => f.getAttribute("index") == "option3");
          fset3 == null ? void 0 : fset3.querySelectorAll(`[data-input]`).forEach((input) => {
            input.removeAttribute("checked");
            input.checked = false;
          });
          const tempInput3 = fset3 == null ? void 0 : fset3.querySelector(`[value="${variant == null ? void 0 : variant.option3}"]`);
          if (tempInput3)
            tempInput3.checked = true;
        } else if (elm.name == "option3") {
          const fset3 = this.fieldsets.find((f) => f.getAttribute("index") == "option3");
          const tempInput3 = fset3 == null ? void 0 : fset3.querySelector(`[value="${variant == null ? void 0 : variant.option3}"]`);
          if (tempInput3)
            tempInput3.checked = true;
        }
      }
      this.previousVariant = currentVariant;
      GlobalEvents.emit("form:changeOption");
      x == null ? void 0 : x.emit("change", { id: currentVariant == null ? void 0 : currentVariant.id });
    });
  }
};
__decorateClass([
  liquidValue("block.id")
], PbCommonVariantPicker.prototype, "blockId", 2);
__decorateClass([
  liquidValue("block.settings.show_unavailable")
], PbCommonVariantPicker.prototype, "showUnavailable", 2);
__decorateClass([
  liquidValue("product.variants")
], PbCommonVariantPicker.prototype, "variants", 2);
__decorateClass([
  queryAll("fieldset")
], PbCommonVariantPicker.prototype, "fieldsets", 2);
__decorateClass([
  queryAll("[data-option]")
], PbCommonVariantPicker.prototype, "options", 2);
__decorateClass([
  on("click", "[data-input]")
], PbCommonVariantPicker.prototype, "handleClick", 1);
PbCommonVariantPicker = __decorateClass([
  defineElement("pb-common-variant-picker")
], PbCommonVariantPicker);
export {
  PbCommonVariantPicker
};
